import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';
import { useCurrentUserId } from './useCurrentUserId';

interface UseBusinessRoleResult {
  role: API.BusinessMembershipRole | undefined;
  isBusinessAdmin: boolean | undefined;
  loading: boolean;
}

export function useBusinessRole(): UseBusinessRoleResult {
  const userId = useCurrentUserId();
  const { data, loading } = useQuery<
    API.GetBusinessMembershipQuery,
    API.GetBusinessMembershipQueryVariables
  >(Queries.business.getBusinessMembership, {
    variables: { userId: userId ?? -1 },
    skip: isNil(userId),
  });

  return useMemo(() => {
    const role = data?.getBusinessMembership?.role ?? undefined;
    return {
      role,
      isBusinessAdmin: isNil(role) ? undefined : role === 'ADMIN' || role === 'OWNER',
      loading,
    };
  }, [data, loading]);
}
